import clsx from "clsx";
import { motion } from "framer-motion";
import React, { forwardRef } from "react";

export interface CompanySiteListItemProps {
  className?: string;
  site: Queries.CompanySiteDataFragment;
  index?: number;
  onClick: () => void;
  shouldAnimate?: boolean;
  variant: "primaryBackground" | "darkBackground";
}

export const CompanySiteListItem = forwardRef<HTMLDivElement, CompanySiteListItemProps>(
  ({ site, index, onClick, shouldAnimate = true, className, variant }, ref) => {
    return (
      <motion.div
        onClick={onClick}
        ref={ref}
        initial={{ x: "-100%" }}
        animate={shouldAnimate ? { x: 0 } : undefined}
        transition={{ duration: 0.5, delay: (index ?? 0) / 15 }}
        className={clsx(
          "border-b py-2 border-opacity-50",
          variant === "primaryBackground" && "border-b-light",
          variant === "darkBackground" && "border-b-light",
          className
        )}
      >
        <div className="text-lg lg:text-2xl font-bold uppercase">{site.name}</div>
        <div className="font-thin lg:text-xl">
          {[site.city, site.country].filter(Boolean).join(", ")}
        </div>
      </motion.div>
    );
  }
);
